/**
 * DPos
 * API for DPos
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Merchant } from './merchant';
import { PaymentOrderItem } from './paymentOrderItem';
import { Staff } from './staff';
import { StaffMeal } from './staffMeal';
import { TableMerchant } from './tableMerchant';
import { Membership } from './membership';
import { PaymentMethod } from './paymentMethod';
import { PaymentItem } from './paymentItem';


export interface Payment { 
    appliedMembershipPoint?: number;
    buzzerNo?: string;
    changeAmount?: number;
    chargesAmount?: number;
    createdByName?: string;
    creationTime?: string;
    deleted?: boolean;
    discountAmount?: number;
    discountBy?: string;
    discountItemAmount?: number;
    discountPercentage?: number;
    discountRemarks?: string;
    ewalletReferenceNo?: string;
    id?: number;
    inclusiveTax?: number;
    membership?: Membership;
    membershipPoint?: number;
    merchant?: Merchant;
    netAmount?: number;
    paidAmount?: number;
    paxNo?: number;
    paymentItems?: Array<PaymentItem>;
    paymentMethod?: PaymentMethod;
    paymentMethodUpdateRemark?: string;
    paymentMethodUpdatedAt?: string;
    paymentMethodUpdatedBy?: string;
    paymentNo?: string;
    paymentOrderItems?: Array<PaymentOrderItem>;
    paymentStatus?: Payment.PaymentStatusEnum;
    previousPaymentMethod?: PaymentMethod;
    queueNo?: string;
    roundingAmount?: number;
    staffMeal?: StaffMeal;
    staffMealAmount?: number;
    staffMealNewBalance?: number;
    staffMealPreviousBalance?: number;
    staffMealStaff?: Staff;
    tableId?: number;
    tableMerchant?: TableMerchant;
    tax1Amount?: number;
    tax2Amount?: number;
    tipsAmount?: number;
    totalAmount?: number;
    updateTime?: string;
    updatedByName?: string;
    voidDate?: string;
    voidRemark?: string;
    voidUser?: string;
}
export namespace Payment {
    export type PaymentStatusEnum = 'PAID' | 'UNPAID' | 'VOIDED';
    export const PaymentStatusEnum = {
        Paid: 'PAID' as PaymentStatusEnum,
        Unpaid: 'UNPAID' as PaymentStatusEnum,
        Voided: 'VOIDED' as PaymentStatusEnum
    };
}


